/*
 *   File : minor-pan-details.js
 *   Author URI : https://evoqins.com
 *   Description :  Component will allow the customer to submit PAN details.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";


import { CustomFilePicker, CustomSelectBox, CustomTextInput, DatePicker, FilePreview, RadioGroup } from "../../../../Component/Form-elements";
import { GradientButton } from "../../../../Component/CTA";

import APIService from "../../../../Service/api-service";
import { _convertToLabelIdArray, _isFileTypeAllowed } from "../../../../Helper";
import { _uploadDocumentToS3 } from "../../../../Service/aws-service";
import { _getKycProfile } from "../../../../Helper/api";
import Store from "../../../../Store";


const NRIAddressDetailsPage = (props) => {


    const PROGRESS_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);
    console.log('PROGRESS_DATA', PROGRESS_DATA);

    const GENERAL_DATA = useSelector(state => state.generalData.GENERAL_DATA);


    const addressRef = useRef();
    const detailsRef = useRef();

    const [fileLoader, setFileLoader] = useState(false);

    const [addressProofOptions, setAddressProofOptions] = useState([]);


    const [overSeasAddressProof, setOverSeasAddressProof] = useState(null);
    const [overSeasAddressProofError, setOverSeasAddressProofError] = useState("");

    const [localAddressProof, setLocalAddressProof] = useState(null);
    console.log('localAddressProof', localAddressProof);

    const [localAddressProofError, setLocalAddressProofError] = useState("");

    const [overseasAddressProofDoc, setOverseasAddressProofDoc] = useState(null);
    const [overseasAddressProofDocError, setOverseasAddressProofDocError] = useState("");
    const [overseasAddressProofDocUrl, setOverseasAddressProofDocUrl] = useState("");

    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine1Error, setAddressLine1Error] = useState('');

    const [addressLine2, setAddressLine2] = useState('');
    const [addressLine2Error, setAddressLine2Error] = useState('');

    const [addressCountry, setAddressCountry] = useState(null);
    const [addressCountryError, setAddressCountryError] = useState("");
    const [addressCity, setAddressCity] = useState("");
    const [addressCityError, setAddressCityError] = useState("");

    const [pinCode, setPinCode] = useState('');
    const [pinCodeError, setPinCodeError] = useState('');

    const [localAddressProofDoc, setLocalAddressProofDoc] = useState(null);
    const [localAddressProofDocError, setLocalAddressProofDocError] = useState("");
    const [localAddressProofDocUrl, setLocalAddressProofDocUrl] = useState("");
    console.log('localAddressProofDocUrl', localAddressProofDocUrl);


    const [addressLine1p, setAddressLine1p] = useState('');
    const [addressLine1pError, setAddressLine1pError] = useState('');

    const [addressLine2p, setAddressLine2p] = useState('');
    const [addressLine2pError, setAddressLine2pError] = useState('');

    const [addressCountryP, setAddressCountryP] = useState({ label: "India", value: 101 });
    const [addressCountryPError, setAddressCountryPError] = useState("");

    const [addressStateP, setAddressStateP] = useState(null);
    console.log('addressCountryP', addressCountryP);

    const [addressStatePError, setAddressStatePError] = useState("");

    const [countryId, setCountryId] = useState(101);
    console.log('countryId', countryId);


    const [addressStatePText, setAddressStatePText] = useState('');
    const [addressStatePTextError, setAddressStatePTextError] = useState('');

    const [addressCityPText, setAddressCityPText] = useState('');
    const [addressCityPTextError, setAddressCityPTextError] = useState('');

    const [addressCityP, setAddressCityP] = useState(null);
    const [addressCityPError, setAddressCityPError] = useState("");

    const [pinCodeP, setPinCodeP] = useState('');
    const [pinCodePError, setPinCodePError] = useState('');

    const [countryOption, setCountryOptions] = useState([]);
    const [overseasCountryOptions, setOverseasCountryOptions] = useState([]);

    const [stateOption, setStateOptions] = useState([]);
    const [cityOption, setCityOptions] = useState([]);


    const [stateOption1, setStateOptions1] = useState([]);
    const [cityOption1, setCityOptions1] = useState([]);

    const [apiLoader, setApiLoader] = useState(false);

    useEffect(() => {
        _getCountries();
    }, []);



    useEffect(() => {
        if (Object.keys(GENERAL_DATA).length > 0) {

            const address_proof = GENERAL_DATA.address_proof.length > 0 && GENERAL_DATA.address_proof.map((item) => {
                return ({
                    label: item.name,
                    value: item.id
                })
            })
            setAddressProofOptions(address_proof);
        }
    }, [GENERAL_DATA]);

    useEffect(() => {



        if (PROGRESS_DATA.nri_info?.local_address !== null) {
            setAddressLine1p(PROGRESS_DATA.nri_info?.local_address?.line1);
            setAddressLine2p(PROGRESS_DATA.nri_info?.local_address?.line2);
            setPinCodeP(PROGRESS_DATA.nri_info?.local_address.pincode);
            setAddressCountryP({ label: PROGRESS_DATA.nri_info?.local_address?.country_name, value: PROGRESS_DATA.nri_info?.local_address?.country_id });
            _getStates(PROGRESS_DATA.nri_info?.local_address?.country_id, 2);
            setAddressStateP({ label: PROGRESS_DATA.nri_info?.local_address?.state_name, value: PROGRESS_DATA.nri_info?.local_address?.state_id });
            _getCities(PROGRESS_DATA.nri_info?.local_address?.state_id, 2);
            setAddressCityP({ label: PROGRESS_DATA.nri_info?.local_address?.city_name, value: PROGRESS_DATA.nri_info?.local_address?.city_id });
            if (PROGRESS_DATA.nri_info?.local_address?.proof_type_id) {
                setLocalAddressProof({ label: PROGRESS_DATA.nri_info?.local_address?.proof_type, value: PROGRESS_DATA.nri_info?.local_address?.proof_type_id });
            }
            if (PROGRESS_DATA.nri_info?.local_address.country_id !== null) {
                setCountryId(PROGRESS_DATA.nri_info?.local_address.country_id)
            }
            if (PROGRESS_DATA.nri_info?.local_address?.proof_url) {
                const file_name = PROGRESS_DATA.nri_info?.local_address?.proof_url.substring(PROGRESS_DATA.nri_info?.local_address?.proof_url.lastIndexOf('/') + 1, PROGRESS_DATA.nri_info?.local_address?.proof_url.indexOf('?'));
                setLocalAddressProofDoc(file_name)
                setLocalAddressProofDocUrl(PROGRESS_DATA.nri_info?.local_address?.proof_url);
            }
        }

        if (PROGRESS_DATA.nri_info?.overseas_address !== null) {
            setAddressLine1(PROGRESS_DATA.nri_info?.overseas_address?.line1);
            setAddressLine2(PROGRESS_DATA.nri_info?.overseas_address?.line2);
            setPinCode(PROGRESS_DATA.address.permanent_address_pincode);
            setAddressCountry({ label: PROGRESS_DATA.nri_info?.overseas_address?.country_name, value: PROGRESS_DATA.nri_info?.overseas_address?.country_id });
            setAddressCity(PROGRESS_DATA.nri_info?.overseas_address?.city_name);
            if (PROGRESS_DATA.nri_info?.overseas_address?.proof_type_id) {
                setOverSeasAddressProof({ label: PROGRESS_DATA.nri_info?.overseas_address?.proof_type, value: PROGRESS_DATA.nri_info?.overseas_address?.proof_type_id });
            }
            if (PROGRESS_DATA.nri_info?.overseas_address?.proof_url) {
                const file_name = PROGRESS_DATA.nri_info?.overseas_address?.proof_url.substring(PROGRESS_DATA.nri_info?.overseas_address?.proof_url.lastIndexOf('/') + 1, PROGRESS_DATA.nri_info?.overseas_address?.proof_url.indexOf('?'));
                setOverseasAddressProofDoc(file_name)
                setOverseasAddressProofDocUrl(PROGRESS_DATA.nri_info?.overseas_address?.proof_url);
            }
        }

    }, [PROGRESS_DATA]);



    const _handleOverseasAddressProof = (path, file) => {
        let file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setOverseasAddressProofDocError("");
                    setFileLoader(4);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(4);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setOverseasAddressProofDocUrl(response.data.view_info); // file got uploaded successfully
                                setOverseasAddressProofDoc(file_formatted);

                                setFileLoader(false);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setOverseasAddressProofDocError("File size should be less than 5mb");
                }
            }
            else {
                setOverseasAddressProofDocError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }

    const _handleLocalAddressProof = (path, file) => {
        let file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setLocalAddressProofDocError("");
                    setFileLoader(5);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(5);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setLocalAddressProofDocUrl(response.data.view_info); // file got uploaded successfully
                                setLocalAddressProofDoc(file_formatted);

                                setFileLoader(false);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setLocalAddressProofDocError("File size should be less than 5mb");
                }
            }
            else {
                setLocalAddressProofDocError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }


    // API - get countries
    const _getCountries = () => {
        const url = "general/countries";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                const countries = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.country_id
                    })
                })

                const overseas_countries = response.data
                    .filter((item) => item.country_id !== 101) //  remove India
                    .map((item) => {
                        return {
                            label: item.name,
                            value: item.country_id
                        }
                    });

                setCountryOptions(countries);
                setOverseasCountryOptions(overseas_countries);
                if (PROGRESS_DATA.address.current_address_country_id === null) {
                    _getStates(101, 2);
                }
            }
        })
    }

    // API - get countries
    const _getStates = (id, type) => {
        const url = "general/states";

        const data = {
            "country_id": Number(id)
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                const states = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.state_id
                    })
                })

                if (type === 1) {
                    setStateOptions(states);
                } else {
                    setStateOptions1(states);
                }
            } else {
                if (type === 1) {
                    setStateOptions([]);
                } else {
                    setStateOptions1([]);
                }
            }
        })
    }

    // API - get cities
    const _getCities = (id, type) => {
        const url = "general/cities";

        const data = {
            "state_id": Number(id)
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                const cities = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.city_id
                    })
                })
                if (type === 1) {
                    setCityOptions(cities);
                } else {
                    setCityOptions1(cities);
                }

            } else {
                if (type === 1) {
                    setCityOptions([]);
                } else {
                    setCityOptions1([]);
                }

            }
        })
    }

    console.log("overseasAddressProofDocUrl", overseasAddressProofDocUrl);


    const _addAddressDetails = () => {
        const url = "kyc/add-nri-address";
        setApiLoader(true);
        const request = {
            "local_address_proof_id": localAddressProof ? localAddressProof.value : null,
            "overseas_address_proof_id": overSeasAddressProof ? overSeasAddressProof.value : null,
            "local_address_proof_url": localAddressProofDocUrl,
            "overseas_address_proof_url": overseasAddressProofDocUrl,
            "local_address": {
                "line1": addressLine1p,
                "line2": addressLine2p,
                "country_id": addressCountryP.value,
                "state_id": addressStateP?.value,
                "city_id": addressCityP ? addressCityP?.value : null,
                "city_name": null,
                "pincode": pinCodeP
            },
            "overseas_address": {
                "line1": addressLine1,
                "line2": addressLine2,
                "country_id": addressCountry.value,
                "state_id": null,
                "state_name": null,
                "city_id": null,
                "city_name": addressCity,
                "pincode": pinCode
            }
        }

        APIService(true, url, request).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {

                // setKycCheckBtn(true);
                props.updateProgress(response.kyc_data.is_review ? 10 : 6, "NRI")
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                toast.success("Address details submitted successfully");

            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        })
    }

    function _validateForm() {
        let valid = true;

        if (localAddressProof === null) {
            detailsRef.current.scrollIntoView({ block: "start" });
            setLocalAddressProofError("Please select Address proof");
            valid = false;
        }

        if (countryId !== 101) {
            if (addressCityPText.trim().length === 0) {
                valid = false;
                setAddressCityPTextError("Please provide city name")
            }

            if (addressStatePText.trim().length === 0) {
                valid = false;
                setAddressStatePTextError("Please provide state name")
            }
        } else {
            if (addressStateP === null) {
                valid = false;
                setAddressStatePError('State is required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
            if (addressCityP === null) {
                valid = false;
                setAddressCityPError('City is required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
        }

        if (localAddressProofDocUrl === "") {
            detailsRef.current.scrollIntoView({ block: "start" });
            setLocalAddressProofDocError("Please upload Address proof");
            valid = false;
        }
        if (addressLine1p.length === 0) {
            valid = false;
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            setAddressLine1pError('Address line1 is required');
        }
        if (addressLine2p.length === 0) {
            valid = false;
            setAddressLine2pError('Address line2 is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (addressCountryP === null) {
            valid = false;
            setAddressCountryPError('Country is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (pinCodeP.length === 0) {
            valid = false;
            setPinCodePError('Pin code in required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCodeP.length !== 0 && pinCodeP.length !== 6) {
            valid = false;
            setPinCodePError('Invalid pin code');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (overSeasAddressProof === null) {
            addressRef.current.scrollIntoView({ block: "start" });
            setOverSeasAddressProofError("Please select Address proof");
            valid = false;
        }
        if (overseasAddressProofDocUrl === "") {
            addressRef.current.scrollIntoView({ block: "start" });
            setOverseasAddressProofDocError("Please upload Address proof");
            valid = false;
        }

        if (addressLine1.length === 0) {
            valid = false;
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            setAddressLine1Error('Address line1 is required');
        }
        if (addressLine2.length === 0) {
            valid = false;
            setAddressLine2Error('Address line2 is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (addressCountry === null) {
            valid = false;
            setAddressCountryError('Country is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (addressCity === "") {
            valid = false;
            setAddressCityError('City is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCode.length === 0) {
            valid = false;
            setPinCodeError('Pin code in required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCode.length !== 0 && pinCode.length !== 6) {
            valid = false;
            setPinCodeError('Invalid pin code');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }



        if (valid === true) {
            _addAddressDetails();
        }

    }
    return (
        <div>
            <p className="color-black e-poppins e-poppins-bold e-font-24 mb-0" ref={addressRef}>Add your addresses</p>
            <p className="color-outer-space e-poppins-regular e-font-16 line-height-24px mb-0 pt-2" >We require both your local and overseas addresses.</p>
            <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px border-radius-8px bg-beige w-fit-content py-3 px-5 my-4">
                USA/Canada citizens cannot proceed due to compliance.
            </p>
            <div className="row pt-2">
                <h6 className="color-black e-font-18-sm-16 e-poppins-medium mb-4">
                    Add your overseas address
                </h6>
                <div className="col-lg-4 col-sm-6 col-12">
                    <CustomTextInput value={addressLine1}
                        label="Address 1"
                        postfix="*"
                        onEnter={_validateForm}
                        error={addressLine1Error}
                        handleChange={(e) => { setAddressLine1(e); setAddressLine1Error('') }} />
                </div>
                <div className="col-lg-4 col-sm-6 col-12 pt-sm-0 pt-4 mt-sm-0 mt-2">
                    <CustomTextInput value={addressLine2}
                        label="Address 2"
                        postfix="*"
                        onEnter={_validateForm}
                        error={addressLine2Error}
                        handleChange={(e) => { setAddressLine2(e); setAddressLine2Error('') }} />
                </div>


                <div className="col-lg-4 col-sm-6 col-12 pt-lg-0 pt-4 mt-lg-0 mt-2">
                    <CustomSelectBox value={addressCountry}
                        label="Country"
                        postfix="*"
                        isSearchable={true}
                        error={addressCountryError}
                        options={overseasCountryOptions}
                        onInputChange={() => setAddressCountryError("")}
                        onSelectChange={(e) => {
                            setAddressCountry(e);
                            setAddressCity("");
                            setAddressCountryError("");
                        }} />
                </div>


                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomTextInput value={addressCity}
                        label="City"
                        postfix="*"
                        onEnter={_validateForm}
                        error={addressCityError}
                        options={cityOption}
                        isSearchable={true}
                        onInputChange={() => setAddressCityError("")}
                        handleChange={(e) => {
                            setAddressCity(e);
                            setAddressCityError("");
                        }} />
                </div>

                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomTextInput value={pinCode}
                        label="Postal code"
                        postfix="*"
                        type="number"
                        onEnter={_validateForm}
                        error={pinCodeError}
                        options={stateOption}
                        maxLength={6}
                        handleChange={(e) => {
                            setPinCode(e);
                            setPinCodeError('')
                        }} />
                </div>


            </div>

            <div className="row">
                <div className="col-md-12 pt-4">
                    <h6 className="color-black e-font-18-sm-16 e-poppins-medium mb-3">
                        Upload address proof
                    </h6>
                </div>
                <div className="col-md-4">
                    <CustomSelectBox value={overSeasAddressProof}
                        label="Choose Document"
                        postfix="*"
                        error={overSeasAddressProofError}
                        options={addressProofOptions}
                        onSelectChange={(input_value) => {
                            setOverSeasAddressProof(input_value);
                            setOverSeasAddressProofError("");
                        }} />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 py-4">

                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={overseasAddressProofDocError}
                        loading={fileLoader === 4 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleOverseasAddressProof(path, file);
                        }} />
                    {
                        overseasAddressProofDoc === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={overseasAddressProofDoc}
                                    removeFile={() => {
                                        setOverseasAddressProofDoc(null);
                                        setOverseasAddressProofDocUrl("");
                                    }} />
                            </div>
                    }
                </div>
            </div>

            <div className="row pt-2" ref={detailsRef}>
                <h6 className="color-black e-font-18-sm-16 e-poppins-medium mb-4">
                    Add your local address
                </h6>
                <div className="col-lg-4 col-sm-6 col-12">
                    <CustomTextInput value={addressLine1p}
                        label="Address 1"
                        postfix="*"
                        onEnter={_validateForm}
                        id="local_address_line1"
                        error={addressLine1pError}
                        handleChange={(e) => {
                            setAddressLine1p(e);
                            setAddressLine1pError('')
                        }} />
                </div>

                <div className="col-lg-4 col-sm-6 col-12 pt-sm-0 pt-4 mt-sm-0 mt-2">
                    <CustomTextInput value={addressLine2p}
                        label="Address 2"
                        onEnter={_validateForm}
                        postfix="*"
                        id="local_address_line2"
                        error={addressLine2pError}
                        handleChange={(e) => {
                            setAddressLine2p(e);
                            setAddressLine2pError('')
                        }} />
                </div>


                <div className="col-lg-4 col-sm-6 col-12 pt-lg-0 pt-4 mt-lg-0 mt-2">
                    <CustomSelectBox value={addressCountryP}
                        label="Country"
                        postfix="*"
                        isSearchable={true}
                        error={addressCountryPError}
                        options={countryOption}
                        onInputChange={() => setAddressCountryPError("")}
                        onSelectChange={(e) => {
                            setAddressCountryP(e);
                            setCountryId(e.value)
                            _getStates(e.value, 2);
                            setAddressStateP(null);
                            setAddressCityP(null);
                            setAddressCountryPError("");
                        }} />
                </div>

                {countryId === 101 ?
                    <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                        <CustomSelectBox value={addressStateP}
                            label="State"
                            postfix="*"
                            error={addressStatePError}
                            options={stateOption1}
                            isSearchable={true}
                            isDisabled={addressCountryP === null ? true : false}
                            onInputChange={() => setAddressStatePError("")}
                            onSelectChange={(e) => {
                                setAddressStateP(e);
                                _getCities(e.value, 2);
                                setAddressCityP(null);
                                setAddressStatePError("");
                            }} />
                    </div>
                    :
                    <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                        <CustomTextInput value={addressStatePText}
                            label="State"
                            postfix="*"
                            onEnter={_validateForm}
                            type="text"
                            error={addressStatePTextError}
                            maxLength={6}
                            handleChange={(e) => {
                                setAddressStatePText(e);
                                setAddressStatePTextError('')
                            }} />
                    </div>
                }



                {countryId === 101 ?
                    <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                        <CustomSelectBox value={addressCityP}
                            label="City"
                            postfix="*"
                            isDisabled={addressStateP === null ? true : false}
                            error={addressCityPError}
                            options={cityOption1}
                            isSearchable={true}
                            onInputChange={() => setAddressCityPError("")}
                            onSelectChange={(e) => {
                                setAddressCityP(e);
                                setAddressCityPError("");
                            }} />
                    </div>
                    :
                    <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                        <CustomTextInput value={addressCityPText}
                            label="City"
                            onEnter={_validateForm}
                            postfix="*"
                            type="text"
                            error={addressCityPTextError}
                            maxLength={6}
                            handleChange={(e) => {
                                setAddressCityPText(e);
                                setAddressCityPTextError('')
                            }} />
                    </div>
                }

                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomTextInput value={pinCodeP}
                        label="Postal code"
                        postfix="*"
                        onEnter={_validateForm}
                        type="number"
                        error={pinCodePError}
                        maxLength={6}
                        handleChange={(e) => {
                            setPinCodeP(e);
                            setPinCodePError('')
                        }} />
                </div>


            </div>

            <div className="row">
                <div className="col-md-12 pt-4">
                    <h6 className="color-black e-font-18-sm-16 e-poppins-medium mb-3">
                        Upload address proof
                    </h6>
                </div>
                <div className="col-md-4">
                    <CustomSelectBox value={localAddressProof}
                        label="Choose Document"
                        postfix="*"
                        error={localAddressProofError}
                        options={addressProofOptions}
                        onSelectChange={(input_value) => {
                            setLocalAddressProof(input_value);
                            setLocalAddressProofError("");
                        }} />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 pt-4">

                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={localAddressProofDocError}
                        loading={fileLoader === 5 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleLocalAddressProof(path, file);
                        }} />
                    {
                        localAddressProofDoc === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={localAddressProofDoc}
                                    removeFile={() => {
                                        setLocalAddressProofDoc(null);
                                        setLocalAddressProofDocUrl("");
                                    }} />
                            </div>
                    }
                </div>
            </div>

            <GradientButton label={"Continue"}
                loading={apiLoader}
                className="px-3 padding-12px-tb e-font-16 margin-40px-top-sm-16 mob-w-100"
                handleClick={() => _validateForm()} />

        </div>
    )
}
export default NRIAddressDetailsPage